import mod from "-!../../node_modules/framevuerk-builder/node_modules/babel-loader/lib/index.js??ref--1!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/index.js??vue-loader-options!./fvAvatar.vue?vue&type=script&lang=js&"; export default mod; export * from "-!../../node_modules/framevuerk-builder/node_modules/babel-loader/lib/index.js??ref--1!../../node_modules/framevuerk-builder/node_modules/vue-loader/lib/index.js??vue-loader-options!./fvAvatar.vue?vue&type=script&lang=js&"


//////////////////
// WEBPACK FOOTER
// ./src/components/fvAvatar.vue?vue&type=script&lang=js&
// module id = 64
// module chunks = 0 1